import React from 'react'
import { Link } from 'react-router-dom'

export default function Breadcrumb({breadcrumbData}) {
  return (
    <>
      <section className={`dynamic-breadcrumb ${breadcrumbData?.newClass}`}>
        <ul>
          {breadcrumbData?.list && breadcrumbData?.list.map((data, index) => (
            <li key={index}><Link  to={data?.slug}>{data?.page}</Link></li>
          ))}
        </ul>
      </section>
    </>
  )
}
